import { onAuthStateChanged } from "firebase/auth";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { auth } from "../firebase/firebase";
import { logout, setUser } from "../store/slices/session/sessionSlice";

const useAuthListener = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        console.log("User logged in:", user.email);
        const token = await user.getIdToken();

        dispatch(
          setUser({
            uid: user.uid,
            email: user.email,
            token,
            creationTime: user.metadata.creationTime,
            lastSignInTime: user.metadata.lastSignInTime,
          })
        );
      } else {
        console.log("User logged out");
        dispatch(logout());
      }
    });

    return () => unsubscribe();
  }, [dispatch]);
};

export default useAuthListener;
